export enum Disposition {    
    LeftMessageOrEmail = 0,
    ComingInForConsult = 1,
    NotReadyYet = 2,
    ReferredToLocalCenter = 3,
    WantedGeneralInfo = 4,
    NotViableCandidate = 5,
    CouldNotContact = 6,
    IsOutsideUsa = 7,
    RecipientTransplanted = 8,
    PendingCleanup = 99,
    PendingJugOnlyShip = 100,
    PendingPreWorkupLabs = 101,
    PendingHospitalVisit = 102,
    IncompletePwl = 150,
    Complete = 200
}